import React, { useEffect, useState } from "react";

interface PropertyResult {
    taxId?: string;
    address?: string;
    legalDescription?: string;
}

interface Property {
    id: string;
    addressLine1?: string;
    legalDescription?: string;
    propertyResult: PropertyResult | null;
}

interface OrderData {
    items: {
        properties: Property[];
    };
}

interface Account {
    orderPropertyId: string;
}

interface Certificate {
    accounts: Account[];
}

interface RequestedInfoSectionProps {
    orderData: any;
    certificate: Certificate;
    showAccount: number;
    isHoaEditor: boolean;
}

export function RequestedInfoSection({
    orderData,
    certificate,
    showAccount = 1,
    isHoaEditor,
}: RequestedInfoSectionProps): JSX.Element {
    const [matchedProperty, setMatchedProperty] = useState<Property | null>(null);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    useEffect(() => {
        const properties = orderData.data?.properties || [];
        const currentOrderPropertyId = certificate?.accounts[showAccount]?.orderPropertyId;
        const item = properties.filter((el: any) => el.id === currentOrderPropertyId);
        if (item.length > 0) {
            setMatchedProperty(item[0]);
        } else {
            setMatchedProperty(null);
        }
    }, [showAccount, orderData?.data?.properties, certificate?.accounts]);


    return (
        <div className="bg-text-1 rounded-[7px] shadow-md pb-2 pt-2 mt-3 col-span-12 grid grid-cols-12 w-full">
            <div className="flex items-center justify-between col-span-12 px-2 py-2">
                <h5 className="text-lg font-semibold">Requested Information</h5>
                <div className="collapse_head ml-auto">
                    <button
                        className="text-highlight-5 focus:outline-none"
                        onClick={toggleCollapse}
                    >
                        <i
                            className={`fa fa-angle-right transition-transform duration-300 ${isCollapsed ? "rotate-90" : ""
                                }`}
                            aria-hidden="true"
                        />
                    </button>
                </div>
               
            </div>
            
            {isCollapsed && (
                <div id="propertyInfo" className="col-span-12  py-2 px-2">
                    
                    <div className="col-md-12 ">
                        <div
                            className={
                                isHoaEditor ? "flex justify-center bg-text-4 border border-text-4 text-text-0 p-[0.3em]" : "flex justify-center bg-highlight-5 border border-highlight-5 text-text-0 p-[0.3em]"
                            }
                        >
                            <b >Property Info</b>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-span-12  bg-surface-5 ">
                            <div className={isHoaEditor ? "border border-text-4" : "border border-highlight-5"}>
                                <table className="text-sm w-full [&_td]:border [&_td]:border-surface-5 p-[6px] text-left">
                                    <tbody>
                                        {matchedProperty === null ? (
                                            <tr className="readonly_bg">
                                                <td className="pl-3 first_td">No information found to display</td>
                                            </tr>
                                        ) : (
                                            <>
                                                <tr className="readonly_bg">
                                                    <td className="pl-3 first_td">Account No.</td>
                                                    <td className="right-align">
                                                        {matchedProperty.propertyResult?.taxId ?? "-"}
                                                    </td>
                                                </tr>
                                                <tr className="readonly_bg">
                                                    <td className="pl-3">Address</td>
                                                    <td className="right-align">
                                                        {matchedProperty.propertyResult?.address ?? matchedProperty.addressLine1}
                                                    </td>
                                                </tr>
                                                <tr className="readonly_bg">
                                                    <td className="pl-3">Legal Description</td>
                                                    <td className="right-align">
                                                        {
                                                            matchedProperty.propertyResult?.legalDescription ??
                                                            matchedProperty.legalDescription
                                                        }
                                                    </td>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}